import React, { useState, useEffect } from 'react';
import { Nav, Navbar, NavDropdown } from '@themesberg/react-bootstrap';
import LOGO from '../../assets/img/logo.jpg';
import { FaSignOutAlt, FaBars } from 'react-icons/fa';
import { FaCalendarAlt, FaUsers, FaCar, FaExclamationTriangle, FaCreditCard, FaList, FaCogs, FaUserTie, FaMoneyBillWave, FaClipboardList } from 'react-icons/fa';

import { logout } from '../../utils/auth';
import { shouldRedirectToLogin } from '../../utils/access';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import VersionSwitch from './VersionSwitch';
import NotificationBell from './NotificationBell';

const SidebarMenu = () => {
  const [userCatMenu, setCatMenu] = useState([]);
  const [userMenu, setMenu] = useState({});
  const [expanded, setExpanded] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const menu = useSelector((state) => state.user.menu);
  const cname = useSelector((state) => state.user.name);
  const userType = useSelector((state) => state.user.userType);

  useEffect(() => {
    const initForm = async () => {
      const data = menu;

      if (shouldRedirectToLogin(data, location.pathname, userType)) {
        navigate('/');
      }
      setMenu(data);
      setCatMenu(Object.keys(data));
    };

    initForm();
  }, [menu, location.pathname, navigate, userType]);

  const get_icon = (cat) => {
    let icon;
    switch (cat) {
      case 'Agendas':
        icon = <FaCalendarAlt className="m-2" />;
        break;
      case 'Usuarios':
        icon = <FaUsers className="m-2" />;
        break;
      case 'Peritaje':
        icon = <FaCar className="m-2" />;
        break;
      case 'Placas Criticas':
        icon = <FaExclamationTriangle className="m-2" />;
        break;
      case 'Pagos':
        icon = <FaCreditCard className="m-2" />;
        break;
      case 'Catalogos':
        icon = <FaList className="m-2" />;
        break;
      case 'Configuracion':
        icon = <FaCogs className="m-2" />;
        break;
      case 'Clientes':
        icon = <FaUserTie className="m-2" />;
        break;
      case 'Caja Menor':
        icon = <FaMoneyBillWave className="m-2" />;
        break;
      case 'PQRS':
        icon = <FaClipboardList className="m-2" />;
        break;
      default:
        icon = null;
    }
    return icon
  }

  return (
    <div className="p-2">
      <Navbar.Brand className='mt-2'>
        <img src={LOGO} alt="logo" width={'75%'} />
      </Navbar.Brand>
      <NotificationBell variant="v1" />
      <Navbar
        expanded={expanded}
        expand="lg"
        bg="white"
        variant="light"
        onToggle={() => setExpanded(!expanded)}
      >
        <Navbar.Toggle aria-controls="responsive-navbar-nav">
          <FaBars />
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav variant="pills" className="flex-column">
            {userCatMenu.map((cat, i) => {
              return (
                <NavDropdown
                  drop='right'
                  key={i}
                  title={<span>{get_icon(cat)}<span>{cat}</span></span>}
                  id="collasible-nav-dropdown"
                >
                  {userMenu[cat].map((opt, j) => (
                    <NavDropdown.Item
                      key={i + '-' + j}
                      onClick={() => navigate(opt.url)}
                    >
                      {opt.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              );
            })}
            <hr className="separator" />
            <div className="my-2">
              <VersionSwitch variant="sidebar" />
            </div>
            <div className="username">{cname}</div>
            <Nav.Link onClick={logout}>
              <FaSignOutAlt /> Cerrar Sesion
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default SidebarMenu;
